import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'StatusTag' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        borderRadius: 96,
        background: '#F8F8F8'
    },
    dot: {
        display: 'block',
        width: 8,
        height: 8,
        borderRadius: 4
    },
    _default: {
        background: '#D7D7D6'
    },
    _green: {
        background: '#48C089'
    },
    _red: {
        background: '#FF5342'
    }
});
